import { Button } from 'components/UI/Button'
import styled from 'styled-components'

export const DotsButton = styled(Button)`
  border-style: none;
  border-radius: 50%;
  color: #c1c1c1;
  font-weight: 600;
  font-size: 24px;
  font-family: serif;
  height: 26px;
  width: 26px;
  background-color: #e6eaf1;
  position: relative;
  cursor: pointer;
  padding: 0;
  margin: 0;
  min-width: auto;

  &:before {
    content: '...';
    position: absolute;
    bottom: 20%;
    left: 0;
    right: 0;
  }

  :hover {
    background-color: #27b3f3;
    color: #fff;
  }
`
export default DotsButton
